module.exports = __webpack_public_path__ + "static/img/puji2.0de7ffae.png";